module.exports = __webpack_public_path__ + "static/media/street-photographer.3208c142.jpg";